<template>
  <div class="applet-qrcode-wrappper" v-show="showApplet" @click.prevent="closeAlert">
    <div class="qrcode-content">
      <img class="content-bg" src="../images/yj_applet_alert.png">
      <div class="content-box">
        <p class="tip1">前往微信小程序查看</p>
        <p class="tip2">长按识别二维码</p>
        <p class="qrcode-img"><img :src="appletQRCodeBase64"></p>
        <p class="bottom-tip" @click.stop="gotoApp">关闭弹窗，去APP使用</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'appletQRCode',
  props: {
    showApplet: {
      type: Boolean,
      default: false
    },
    qrcodeImage: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['shopId']),
    appletQRCodeBase64() {
      return `data:image/png;base64,${this.qrcodeImage}`
    }
  },
  methods: {
    closeAlert() {
      this.$emit('update:showApplet', false)
    },
    gotoApp() {
      this.$emit('update:showApplet', false)
      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const userPath = y === 'spe' ? 'm.yunjiglobal.com' : 't-do-dev.yunjiglobal.com' // 拉起app的现网域名就是m.yunjiglobal.com
      const targetUrl = 'yunji://memberCenter' 
      window.location.href = `
      ${window.location.protocol}//${userPath}/yjbuyer/seller-link?shopId=${this.shopId}&goType=callAppWebUrl&openUrl=${encodeURIComponent(targetUrl)}`
    }
  }
}
</script>

<style lang="less" scoped>
.applet-qrcode-wrappper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .qrcode-content {
    background-color: #fff;
    border-radius: 0.32rem;
    width: 5.12rem;
    height: 7.24rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .content-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .content-box {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .tip1 {
        color: #fff;
        font-size: 0.4rem;
        line-height: 1.4rem;
        height: 1.4rem;
        font-weight: bold;
      }
      .tip2 {
        margin-top: 0.36rem;
        color: #333;
        font-size: 0.28rem;
      }
      .qrcode-img {
        margin-top: 0.64rem;
        width: 3.12rem;
        height: 3.12rem;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .bottom-tip {
        margin-top: 0.44rem;
        font-size: 0.24rem;
        color: #9a9a9a;
        text-decoration: underline;
      }
    }
  }
}
</style>
